import { observer } from "mobx-react-lite"
import { Button } from "./Button"

import BubbleBar from "./BubbleBar"
import { store } from "../stores/Store"
import './Render.scss';
import ExpandIcon from "../icons/ExpandIcon";
import { useWindowSize } from "../effects/useWindowSize";
import { BREAKPOINT_LG } from "../stores/constants";
import OptionsIcon from "../icons/OptionsIcon";
import { publicUrl } from "../utils/url";
import PersonIcon from "../icons/PersonIcon";
import { use, useState } from "react";
import CloseIconBig from "../icons/CloseIconBig";
import { motion } from "motion/react";
import Img from "./Img";
import LogoLoader from "./LogoLoader";
import { Gtm } from "../utils/Gtm";
import { Clarity } from "../utils/Clarity";
import { _t } from '../utils/Lang';


const MobileBar = observer(({ children }) => {
    const [open, setOpen] = useState(false);
    const [active, setActive] = useState(false);
    return <div className="MobileBar">
        <BubbleBar className="BubbleBar--transparent BubbleBar--expanded">
            <div className="relative">
                <Button onClick={() => setOpen(!open)} className={`btn-sm btn-icon  ${open ? "primary" : "white"}`}>
                    {open ? <CloseIconBig /> : <OptionsIcon className={""} />}
                </Button>
                <motion.div
                    animate={{ opacity: open ? 1 : 0, scale: open ? 1 : 0, y: open ? 0 : 20 }}
                    className="pb-2" style={{ display: open ? 'flex' : 'none', flexDirection: 'column', gap: 5, position: 'absolute', left: 0, bottom: '100%', width: 'max-content', transformOrigin: 'bottom left' }}>
                    <Button onClick={() => {
                        store.togglePreviewMode('dimensions');
                        // store.openDimensions(undefined, { showControls: false });
                    }} className={`btn-sm ${store.previewMode.includes('dimensions') ? "primary" : "white"}`}>
                        <svg className='icon' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.11574 13.8397C8.99441 14.1216 8.79871 14.3163 8.52864 14.4239C8.25856 14.5314 7.98258 14.5245 7.70069 14.4032L3.55567 12.6191C3.27378 12.4978 3.07906 12.3021 2.97152 12.032C2.86398 11.762 2.87087 11.486 2.99219 11.2041L6.88477 2.16023C7.0061 1.87834 7.2018 1.68363 7.47188 1.57609C7.74195 1.46854 8.01793 1.47543 8.29982 1.59676L12.4449 3.38083C12.7267 3.50215 12.9215 3.69786 13.029 3.96793C13.1365 4.23801 13.1296 4.51399 13.0083 4.79587L9.11574 13.8397ZM8.50339 13.5762L12.396 4.53231C12.4366 4.43801 12.4345 4.33473 12.3898 4.22246C12.3451 4.1102 12.2756 4.03377 12.1813 3.99318L8.03626 2.20912C7.94196 2.16853 7.83867 2.17058 7.72641 2.21529C7.61414 2.25999 7.53772 2.32949 7.49713 2.4238L6.73688 4.19013L8.71524 5.04164L8.45168 5.654L6.47331 4.80249L5.68262 6.63955L7.66099 7.49106L7.39742 8.10342L5.41906 7.25191L4.62836 9.08897L6.60673 9.94048L6.34317 10.5528L4.3648 9.70133L3.60455 11.4677C3.56396 11.562 3.56602 11.6653 3.61072 11.7775C3.65542 11.8898 3.72493 11.9662 3.81923 12.0068L7.96426 13.7909C8.05856 13.8314 8.16184 13.8294 8.27411 13.7847C8.38637 13.74 8.4628 13.6705 8.50339 13.5762Z" fill="currentColor" />
                        </svg>

                        {_t('full_dimensions')}
                    </Button>
                    <Button onClick={() => {
                        store.togglePreviewMode('person');
                    }} className={`btn-sm ${store.previewMode.includes('person') ? "primary" : "white"}`} >
                        <PersonIcon className={"icon"} />
                        {_t('show_person')}
                    </Button>
                </motion.div>
            </div>

            <span className="m-auto" />

            <Button onClick={() => {
                store.openPreview(store.renderImageUrl, 'xxl', 'none', true);
            }} className={`btn-sm white`}>
                <ExpandIcon className={"icon"} />

                {_t('zoom')}
            </Button>
        </BubbleBar>
    </div>
})
MobileBar.displayName = "MobileBar";

const DesktopBar = observer(({ children }) => {
    const [active, setActive] = useState(false);
    return <div className="DesktopBar">
        <BubbleBar>
            <Button onClick={() => {
                store.togglePreviewMode('dimensions');
                // store.openDimensions(undefined, { showControls: false });

                Gtm.push({
                    event: "konfigurator_click",
                    ecommerce: {
                        button_name: 'pełne wymiary',
                        value: Gtm.getPrice(),
                        items: [
                            {
                                item_name: Gtm.getProductName(),
                                item_id: Gtm.getProductId(),
                                item_brand: "MyBed",
                                item_category: "Łóżka",
                                item_variant: Gtm.getVariantStr(),
                            }
                        ]
                    }
                });
                Clarity.push("konfigurator_click - pełne wymiary");
            }} className={`btn-sm ${store.previewMode.includes('dimensions') ? "primary" : "white"}`}>
                <svg className='icon' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.11574 13.8397C8.99441 14.1216 8.79871 14.3163 8.52864 14.4239C8.25856 14.5314 7.98258 14.5245 7.70069 14.4032L3.55567 12.6191C3.27378 12.4978 3.07906 12.3021 2.97152 12.032C2.86398 11.762 2.87087 11.486 2.99219 11.2041L6.88477 2.16023C7.0061 1.87834 7.2018 1.68363 7.47188 1.57609C7.74195 1.46854 8.01793 1.47543 8.29982 1.59676L12.4449 3.38083C12.7267 3.50215 12.9215 3.69786 13.029 3.96793C13.1365 4.23801 13.1296 4.51399 13.0083 4.79587L9.11574 13.8397ZM8.50339 13.5762L12.396 4.53231C12.4366 4.43801 12.4345 4.33473 12.3898 4.22246C12.3451 4.1102 12.2756 4.03377 12.1813 3.99318L8.03626 2.20912C7.94196 2.16853 7.83867 2.17058 7.72641 2.21529C7.61414 2.25999 7.53772 2.32949 7.49713 2.4238L6.73688 4.19013L8.71524 5.04164L8.45168 5.654L6.47331 4.80249L5.68262 6.63955L7.66099 7.49106L7.39742 8.10342L5.41906 7.25191L4.62836 9.08897L6.60673 9.94048L6.34317 10.5528L4.3648 9.70133L3.60455 11.4677C3.56396 11.562 3.56602 11.6653 3.61072 11.7775C3.65542 11.8898 3.72493 11.9662 3.81923 12.0068L7.96426 13.7909C8.05856 13.8314 8.16184 13.8294 8.27411 13.7847C8.38637 13.74 8.4628 13.6705 8.50339 13.5762Z" fill="currentColor" />
                </svg>

                {_t('full_dimensions')}
            </Button>
            <Button onClick={() => {
                store.togglePreviewMode("person");

                Gtm.push({
                    event: "konfigurator_click",
                    ecommerce: {
                        button_name: 'pokaż osobę',
                        value: Gtm.getPrice(),
                        items: [
                            {
                                item_name: Gtm.getProductName(),
                                item_id: Gtm.getProductId(),
                                item_brand: "MyBed",
                                item_category: "Łóżka",
                                item_variant: Gtm.getVariantStr(),
                            }
                        ]
                    }
                });
                Clarity.push("konfigurator_click - pokaż osobę");

            }} className={`btn-sm ${store.previewMode.includes('person') ? "primary" : "white"}`}>
                <PersonIcon className={"icon"} />
                {_t('show_person')}
            </Button>
            <Button onClick={() => {
                store.openPreview(store.renderImageUrl, 'xxl', 'none', true);

                Gtm.push({
                    event: "konfigurator_click",
                    ecommerce: {
                        button_name: 'powększ',
                        value: Gtm.getPrice(),
                        items: [
                            {
                                item_name: Gtm.getProductName(),
                                item_id: Gtm.getProductId(),
                                item_brand: "MyBed",
                                item_category: "Łóżka",
                                item_variant: Gtm.getVariantStr(),
                            }
                        ]
                    }
                });
                Clarity.push("konfigurator_click - powększ");
            }}
                className="btn-sm white">
                <ExpandIcon className={"icon"} />

                {_t('zoom')}
            </Button>
        </BubbleBar>
    </div>
});
DesktopBar.displayName = "DesktopBar";


const Render = observer(props => {
    const windowSize = useWindowSize();

    const showMobileBar = windowSize.width < BREAKPOINT_LG;


    return <div className="Render">
        <div className="Render__image" style={{ minHeight: 160 }}>

            {/* <img src={store.previewImageUrl} alt="" /> */}
            <Img src={store.renderImageUrl}
                alt=""
                loader={<LogoLoader visible />}
            />

        </div>
        <div className="Render__buttons paddings-x">

            {showMobileBar ? <MobileBar /> : <DesktopBar />}
        </div>

        <button
            onClick={() => {
                store.openOnExit();
            }}
            className="Button-leave-configurator">
            <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 12L1 6L7 0.500001" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            {_t('exit_configurator')}
        </button>
    </div>

})

export default Render